import script from "./language-flags.vue?vue&type=script&setup=true&lang=ts"
export * from "./language-flags.vue?vue&type=script&setup=true&lang=ts"

import "./language-flags.vue?vue&type=style&index=0&id=7c034db7&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c034db7"]])

export default __exports__